import getUnitDefenseAtPosition from '../../entity/getUnitDefenseAtPosition'
import type { Entity } from '../../entity/index'
import type { EntityGridXYV2 } from '../EntityGridXYV2.type'
import getGridIndexListItemByXYOrThrow from '../GridIndex/getGridIndexListItemOrThrow'
import createLazyReadOnlyGridXY from '../createLazyReadOnlyGridXY'

type DefenseValueOrNull = number | null

export default function createLazyDefenseValueGrid(
  // full state width
  gridWidth: number,
  // full state height
  gridHeight: number,
  // full state ents as GridXY
  grid: EntityGridXYV2,
  // unit attempting to move
  unit: Entity
) {
  const lazyCostGrid = createLazyReadOnlyGridXY<DefenseValueOrNull>(
    gridWidth,
    gridHeight,
    function costGridGetter(x: number, y: number): DefenseValueOrNull {
      const positionStack = getGridIndexListItemByXYOrThrow(gridWidth, gridHeight, grid, x, y)
      if (positionStack) {
        return getUnitDefenseAtPosition(unit, positionStack)
      }
      return null
    }
  )
  return lazyCostGrid
}
